import { render, staticRenderFns } from "./ConfiguracaoFechamento.vue?vue&type=template&id=5300ce1e&scoped=true&"
import script from "./ConfiguracaoFechamento.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoFechamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5300ce1e",
  null
  
)

export default component.exports